import type { Listing } from '@thevillages/schemas';

import { Component, inject, input } from '@angular/core';

import { StateService } from '../../services/state/state';
import { HomeListingCard } from './home/home';
import { HomesiteListingCard } from './homesite/homesite';

@Component({
  imports: [HomeListingCard, HomesiteListingCard],
  selector: 'app-listing-card',
  styleUrl: './listing-card.css',
  templateUrl: './listing-card.html',
})
export class ListingCard {
  protected readonly stateService = inject(StateService);

  public readonly initialRender = input(false);
  public readonly listing = input.required<Listing>();

  public showListingDetails(): void {
    this.stateService.selectedListingId.set(this.listing().id);

    this.stateService.notifyParentOfStateChange(
      'HF_EVENT:ANALYTICS',
      { listingId: this.listing().id },
      'home_listing_viewed',
    );
  }
}
